/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.DocumentModifier";
        const DOCUMENT_EVENT_QUEUE_LIMIT = 10;
        class DocumentModifierWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("DocumentModifierWidgetTypeClass.createInstance()");
                    return new DocumentModifierWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("DocumentModifierWidgetTypeClass._storeHtml()");
                    DocumentModifierWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocumentModifierWidgetTypeClass::constructor");
                if (DocumentModifierWidgetInstanceClass.HtmlData != null) {
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/DocumentModifier/document-modifier.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.DocumentModifierWidgetTypeClass = DocumentModifierWidgetTypeClass;
        class DocumentModifierProcessor {
            constructor(core, event, id, errorCallback, _failCallback) {
                this._log = null;
                this._documents = [];
                this._queueLength = 0;
                this._processedItems = 0;
                // Need some error handlers so owners can pass them in
                this._errorCallback = null;
                this._failCallback = null;
                this._documentCallback = null;
                this._finishedCallback = null;
                this.process = (documentCallback, finishedCallback) => {
                    this._log.info("DocumentModifierProcessor.process()");
                    this._documentCallback = documentCallback;
                    this._finishedCallback = finishedCallback;
                    if (this._produceHitList())
                        this._iterateHitList();
                };
                this._callFailedHandler = (json) => {
                    this._log.info("DocumentModifierProcessor._callFailedHandler()");
                    if (this._failCallback)
                        this._failCallback(json);
                    this._itemProcessed();
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("DocumentModifierProcessor._callErrorHandler()");
                    if (this._errorCallback)
                        this._errorCallback(url, status, message);
                    this._itemProcessed();
                };
                // Returns true if document list already populated
                this._produceHitList = () => {
                    this._log.info("DocumentModifierProcessor._produceHitList()");
                    switch (this._event.Target) {
                        case 'CurrentPrimary':
                            if (this._core.Context.PrimaryDocument != null) {
                                // We might need to re-get the document if it has no keyword info
                                if (!this._core.Context.PrimaryDocument.hasOwnProperty('KeywordRecords') ||
                                    (this._core.Context.PrimaryDocument.KeywordRecords == null) ||
                                    (this._core.Context.PrimaryDocument.KeywordRecords.length == 0)) {
                                    this._core.Loader.genericServiceCall(`/Documents.svc/rest/GetDocument/${this._core.Context.PrimaryDocument.ItemNum}`, this._receiveHitList, this._callErrorHandler, this._callFailedHandler);
                                    return false;
                                }
                                else
                                    this._documents.push(this._core.Context.PrimaryDocument);
                            }
                            return true;
                        case 'CurrentRelated':
                            if (this._core.Context.RelatedDocument != null) {
                                if (!this._core.Context.RelatedDocument.hasOwnProperty('KeywordRecords') ||
                                    (this._core.Context.RelatedDocument.KeywordRecords == null) ||
                                    (this._core.Context.RelatedDocument.KeywordRecords.length == 0)) {
                                    this._core.Loader.genericServiceCall(`/Documents.svc/rest/GetDocument/${this._core.Context.RelatedDocument.ItemNum}`, this._receiveHitList, this._callErrorHandler, this._callFailedHandler);
                                    return false;
                                }
                                else
                                    this._documents.push(this._core.Context.RelatedDocument);
                            }
                            return true;
                        case 'Query':
                            let requestSearch = null;
                            if (this._event.Query)
                                requestSearch = this._core.OBHelper.compileFlexSearchFromQueryDef(this._event.Query);
                            else if (this._event.FlexQuery)
                                requestSearch = this._core.OBHelper.flexDefinitionToRequest(this._event.FlexQuery);
                            // Override default keyword suppression, we need the keyword records
                            requestSearch.SuppressKeywords = false;
                            this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._receiveHitList, {}, this._callErrorHandler, this._callFailedHandler);
                            return false;
                    }
                };
                this._receiveHitList = (response) => {
                    this._log.info("DocumentModifierProcessor._receiveHitList()");
                    if (response.hasOwnProperty('Documents') && response.Documents.length > 0) {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`DocumentModifierProcessor._receiveHitList() response has ${response.Documents.length} documents.`);
                        }
                        if ((response.Documents.length == 1) || (this._event.MultipleHitPolicy == 'First')) {
                            this._log.trace("DocumentModifierProcessor._receiveHitList() adding single document.");
                            this._documents.push(response.Documents[0]);
                        }
                        else if (this._event.MultipleHitPolicy == 'All') {
                            this._log.trace("DocumentModifierProcessor._receiveHitList() adding all documents.");
                            this._documents = response.Documents;
                        }
                        else
                            this._log.trace("DocumentModifierProcessor._receiveHitList() adding no documents - unexpected MultipleHitPolicy?");
                    }
                    else {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace("got no documents in query");
                        }
                    }
                    // Go on to the next stage
                    this._iterateHitList();
                };
                this._iterateHitList = () => {
                    this._log.info("DocumentModifierProcessor._iterateHitList()");
                    // Nothing to do, do nothing (except tell our host we have finished)
                    if (this._documents.length == 0) {
                        this._log.trace("DocumentModifierProcessor._iterateHitList() no documents in queue");
                        if (this._finishedCallback)
                            this._finishedCallback(this._id, 0);
                        return;
                    }
                    // How many do we need to have before we are done?
                    this._queueLength = this._documents.length;
                    // Get the actual job done
                    this._documents.forEach(doc => {
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`DocumentModifierProcessor checking document ${doc.ItemNum} applicable`);
                        }
                        // First off we need to determine if this event applies to this document
                        let applies = true;
                        if (this._event.hasOwnProperty('AppliesTo') && (this._event.AppliesTo != null)) {
                            this._event.AppliesTo.forEach(condition => {
                                if (!this._core.Context.evaluateSelectionCriterion(condition, doc))
                                    applies = false;
                            });
                        }
                        if (applies) {
                            if (this._log.isTraceEnabled()) {
                                this._log.trace(`DocumentModifierProcessor document ${doc.ItemNum} applicable - processing`);
                            }
                            if (this._event.EventType == 'EnterWorkflowQueue')
                                this._insertIntoLifecycle(doc);
                            else
                                this._updateKeywords(doc);
                        }
                        else
                            this._itemProcessed();
                    });
                };
                this._insertIntoLifecycle = (doc) => {
                    this._log.info("DocumentModifierProcessor._insertIntoLifecycle()");
                    // Sanity check as usual
                    if (!this._event.hasOwnProperty('Lifecycle') || (!this._event.Lifecycle)) {
                        this._callErrorHandler("", -10, "'EnterWorkflowQueue' type event configured with no valid lifecycle name.");
                        return;
                    }
                    let targetLc = this._core.OBHelper.QueueLifecycles.find(lc => lc.Name == this._event.Lifecycle);
                    if (targetLc == null) {
                        this._callErrorHandler("", -11, "'EnterWorkflowQueue' type event configured with unavailable lifecycle.");
                        return;
                    }
                    this._core.Loader.genericServiceCall(`/Workflow.svc/rest/AddDocumentToWorkFlow/${doc.ItemNum}/${targetLc.Id}`, this._insertedIntoLifecycle.bind(this, doc), this._callErrorHandler, this._callFailedHandler);
                };
                this._insertedIntoLifecycle = (doc, response) => {
                    this._log.info("DocumentModifierProcessor._insertedIntoLifecycle()");
                    this._documentCallback(this._event, doc);
                    this._itemProcessed();
                };
                this._updateKeywords = (doc) => {
                    this._log.info("DocumentModifierProcessor._updateKeywords()");
                    // Sanity check as usual
                    if (!this._event.hasOwnProperty('KeywordUpdates') || (this._event.KeywordUpdates == null) || (this._event.KeywordUpdates.length == 0)) {
                        this._callErrorHandler("", -12, "'KeywordUpdates' type event configured with no keyword modifications.");
                        return;
                    }
                    // We need to submit all the existing keywords, with any requested modifications
                    // Loop with for so we can return completely if we hit a dud
                    let workingCopy = JSON.parse(JSON.stringify(doc.KeywordRecords));
                    for (let i = 0; i < this._event.KeywordUpdates.length; i++) {
                        let update = this._event.KeywordUpdates[i];
                        if (update.TargetType == 'Keyword')
                            this._processKeywordUpdate(workingCopy, update);
                        else if (update.TargetType == 'MIKG')
                            this._processMIKGUpdate(workingCopy, update);
                        else {
                            this._callErrorHandler("", -13, "'KeywordUpdates' update configured with unrecognised target type.");
                            return;
                        }
                    }
                    // Now we actually have to perform the update
                    let request = { KeywordRecords: workingCopy };
                    this._core.Loader.genericServiceCallWithData(`/Documents.svc/rest/UpdateKeywordRecords/${doc.ItemNum}`, JSON.stringify(request), this._keywordsUpdated.bind(this, doc), {}, this._callErrorHandler, this._callFailedHandler);
                };
                this._keywordsUpdated = (doc, response) => {
                    this._log.info("DocumentModifierProcessor._keywordsUpdated()");
                    // We SHOULD be sending back the newly modified document keys here
                    if (response.hasOwnProperty('Documents') && (response.Documents != null) && (response.Documents.length > 0))
                        this._documentCallback(this._event, response.Documents[0]);
                    else
                        this._documentCallback(this._event, doc);
                    this._itemProcessed();
                };
                this._processKeywordUpdate = (workingCopy, update) => {
                    this._log.info("DocumentModifierProcessor._processKeywordUpdate()");
                    // Multi-type thing needs some wrangling - set first then apply macro in case it's empty
                    let newValue = (typeof update.NewValue !== 'object') ? update.NewValue : "";
                    if (newValue)
                        newValue = this._core.Context.applyAllMacros(newValue);
                    let searchValue = (typeof update.SearchValue !== 'object') ? update.SearchValue : "";
                    if (searchValue)
                        searchValue = this._core.Context.applyAllMacros(searchValue);
                    // Do what is requested
                    switch (update.Action) {
                        case 'Add':
                            let addKey = { Id: 0, Name: update.TargetName, Value: newValue };
                            this._getStandaloneRecord(workingCopy).Keywords.push(addKey);
                            break;
                        case 'Delete':
                            this._deleteKeywords(workingCopy, update.TargetName, searchValue);
                            break;
                        case 'DeleteAll':
                            this._deleteKeywords(workingCopy, update.TargetName);
                            break;
                        case 'Replace':
                            this._deleteKeywords(workingCopy, update.TargetName, searchValue);
                            let repKey = { Id: 0, Name: update.TargetName, Value: newValue };
                            this._getStandaloneRecord(workingCopy).Keywords.push(repKey);
                            break;
                        case 'ReplaceAll':
                            this._deleteKeywords(workingCopy, update.TargetName);
                            let raKey = { Id: 0, Name: update.TargetName, Value: newValue };
                            this._getStandaloneRecord(workingCopy).Keywords.push(raKey);
                            break;
                    }
                };
                this._getStandaloneRecord = (workingCopy) => {
                    this._log.info("DocumentModifierProcessor._getStandaloneRecord()");
                    for (let i = 0; i < workingCopy.length; i++) {
                        if (workingCopy[i].Type == 'StandAlone')
                            return workingCopy[i];
                    }
                    // If we get here, we don't have a standalone record
                    let standalone = { Type: 'StandAlone', Name: '', Id: 0, Keywords: [] };
                    // Put it at the beginning so we can find it quickly later
                    workingCopy.unshift(standalone);
                    return standalone;
                };
                this._deleteKeywords = (workingCopy, keyName, specificValue = null) => {
                    this._log.info("DocumentModifierProcessor._deleteKeywords()");
                    workingCopy.forEach(kwr => {
                        if ((kwr.Type == 'StandAlone') || (kwr.Type == 'SingleInstance')) {
                            if (kwr.hasOwnProperty('Keywords') || (kwr.Keywords != null)) {
                                let adjustedKeys = [];
                                while (kwr.Keywords.length > 0) {
                                    let kw = kwr.Keywords.shift();
                                    if (kw.Name != keyName)
                                        adjustedKeys.push(kw);
                                    else if (specificValue && (kw.Value != specificValue))
                                        adjustedKeys.push(kw);
                                }
                                kwr.Keywords = adjustedKeys;
                            }
                        }
                    });
                };
                this._processMIKGUpdate = (workingCopy, update) => {
                    this._log.info("DocumentModifierProcessor._processMIKGUpdate()");
                    // Multi-type thing needs some wrangling
                    let searchValues = (typeof update.SearchValue !== 'object') ? [] : update.SearchValue;
                    switch (update.Action) {
                        case 'Add':
                            this._addKeywordRecord(workingCopy, update);
                            break;
                        case 'Delete':
                            this._deleteKeywordRecords(workingCopy, update.TargetName, searchValues);
                        case 'DeleteAll':
                            this._deleteKeywordRecords(workingCopy, update.TargetName);
                        case 'Replace':
                            let deleteCount = this._deleteKeywordRecords(workingCopy, update.TargetName, searchValues);
                            if (deleteCount > 0)
                                this._addKeywordRecord(workingCopy, update);
                            break;
                        case 'ReplaceAll':
                            this._deleteKeywordRecords(workingCopy, update.TargetName);
                            this._addKeywordRecord(workingCopy, update);
                            break;
                    }
                };
                this._addKeywordRecord = (workingCopy, update) => {
                    this._log.info("DocumentModifierProcessor._addKeywordRecord()");
                    // Multi-type thing needs some wrangling
                    let newValues = (typeof update.NewValue !== 'object') ? [] : update.NewValue;
                    let kwr = { Type: 'MultiInstance', Name: update.TargetName, Id: 0, Keywords: [] };
                    newValues.forEach(val => {
                        kwr.Keywords.push({ Id: 0, Name: val.Name, Value: this._core.Context.applyAllMacros(val.Value) });
                    });
                    workingCopy.push(kwr);
                };
                this._deleteKeywordRecords = (workingCopy, recordName, specificValues = []) => {
                    this._log.info("DocumentModifierProcessor._deleteKeywordRecords()");
                    let updatedRecords = [];
                    while (workingCopy.length > 0) {
                        let current = workingCopy.shift();
                        if (current.Name && (current.Name == recordName)) {
                            if (specificValues.length > 0) {
                                let recordMatched = true;
                                // Run through the test keywords
                                specificValues.forEach(val => {
                                    let match = current.Keywords.find(key => ((key.Name == val.Name) && (key.Value == this._core.Context.applyAllMacros(val.Value))));
                                    if (!match)
                                        recordMatched = false;
                                });
                                if (!recordMatched)
                                    updatedRecords.push(current);
                            }
                        }
                        else
                            updatedRecords.push(current);
                    }
                    // Count the effects
                    let deleteCount = workingCopy.length = updatedRecords.length;
                    // Can't easily reassign, so push our records back
                    while (updatedRecords.length > 0)
                        workingCopy.push(updatedRecords.shift());
                    return deleteCount;
                };
                this._itemProcessed = () => {
                    this._log.info("DocumentModifierProcessor._itemProcessed()");
                    this._processedItems = this._processedItems + 1;
                    if (this._processedItems == this._queueLength)
                        this._finishedCallback(this._id, this._processedItems);
                };
                this._core = core;
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocumentModifierProcessor::constructor");
                this._event = event;
                this._id = id;
                this._errorCallback = errorCallback;
                this._failCallback = _failCallback;
                if (event == null)
                    console.error('DocumentModifierProcessor created with null even');
                else if (this._log.isTraceEnabled) {
                    this._log.trace(`DocumentModifierProcessor for event '${event.Identifier}' created`);
                }
            }
            get Event() {
                return this._event;
            }
        }
        Widgets.DocumentModifierProcessor = DocumentModifierProcessor;
        class DocumentModifierWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                this._instanceSelector = null;
                this._outerDiv = null;
                this._stealthHideButton = null;
                this._decloakOnError = false;
                this._suppressMessages = false;
                // The important workings
                this._events = [];
                this._queueSizeLimit = DOCUMENT_EVENT_QUEUE_LIMIT;
                this._triggers = null;
                this._eventQueue = [];
                this._flushingQueue = false;
                this._processCounter = 0;
                this._activeProcessors = {};
                this._asynchronous = true;
                this._eventInProgress = false;
                this.presentInstance = () => {
                    this._log.info("DocumentModifierWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = DocumentModifierWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    this._outerDiv = this._container.querySelector('div.widget');
                    this._stealthHideButton = this._container.querySelector('#documentModifierStealthButton');
                    this._stealthHideButton.addEventListener('click', this._stealthHide);
                    this._core.Helper.setElementTranslationAttribute(this._stealthHideButton, 'title', 'STR_WPT_HIDE');
                    this._widgets.setTitle(this._config, this._container.querySelector('#documentModifierWidgetHeading'), 'STR_WPT_DOCUMENT_MODIFIER');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    let config = this._config;
                    if (config.hasOwnProperty('DecloakOnError') && (config.DecloakOnError))
                        this._decloakOnError = true;
                    if (config.hasOwnProperty('SuppressMessages') && (config.SuppressMessages))
                        this._suppressMessages = true;
                    if (config.hasOwnProperty('Asynchronous') && (config.Asynchronous != null))
                        this._asynchronous = config.Asynchronous;
                    if (config.hasOwnProperty('QueueSizeLimit') && (config.QueueSizeLimit != null))
                        this._queueSizeLimit = config.QueueSizeLimit;
                    if (config.hasOwnProperty('Events') && config.Events && (config.Events.length > 0))
                        this._events = config.Events;
                    else
                        this._events = [];
                    if (this._events.length == 0) {
                        console.warn("DocumentModifier configured with no events - it's not going do do anything!");
                    }
                    let indexer = 1;
                    this._events.forEach(event => {
                        if (!event.hasOwnProperty('Identifier') || (!event.Identifier))
                            event.Identifier = indexer.toString();
                        if (!event.hasOwnProperty('Target') || (!event.Target))
                            event.Target = 'CurrentPrimary';
                        if (!event.hasOwnProperty('MultipleHitPolicy') || (!event.MultipleHitPolicy))
                            event.MultipleHitPolicy = 'First';
                        indexer++;
                    });
                    if (config.hasOwnProperty('EventTriggers') && config.EventTriggers && (config.EventTriggers.length > 0))
                        this._triggers = config.EventTriggers;
                    else
                        this._triggers = [];
                    if (this._triggers.length == 0) {
                        console.warn("DocumentModifier configured with no triggers - it's not going do do anything!");
                    }
                    this._core.Functions.addDefaultsToTriggerEvents(this._triggers);
                    this._triggers.forEach(trigger => {
                        if (!trigger.hasOwnProperty('Context') || (trigger.Context == null))
                            trigger.Context = '**UNDEFINED!**';
                        let triggeredEvent = this._events.find(e => e.Identifier == trigger.Context);
                        if (!triggeredEvent) {
                            console.warn(`DocumentModifier configured with trigger for undefined event ${trigger.Context}`);
                        }
                    });
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("DocumentModifierWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                    if (this._decloakOnError)
                        this._core.Functions.showElement(this._outerDiv);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("DocumentModifierWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                    if (this._decloakOnError)
                        this._core.Functions.showElement(this._outerDiv);
                };
                this._stealthHide = (event) => {
                    this._log.info("DocumentModifierWidgetInstanceClass._stealthHide()");
                    this._core.Functions.hideElement(this._outerDiv);
                };
                this._processEventQueue = () => {
                    this._log.info("DocumentModifierWidgetInstanceClass._processEventQueue()");
                    if (this._asynchronous) {
                        while (this._eventQueue.length > 0) {
                            this._processEvent(this._eventQueue.shift());
                        }
                    }
                    else if (this._eventQueue.length > 0)
                        this._processEvent(this._eventQueue.shift());
                };
                this._processEvent = (event) => {
                    this._log.info("DocumentModifierWidgetInstanceClass._processEvent()");
                    if (event == null) {
                        console.warn("DocumentModifierWidgetInstanceClass._processEvent() attempt to process null event - aborting.");
                        return;
                    }
                    if (!this._asynchronous)
                        this._eventInProgress = true;
                    let id = this._processCounter.toString();
                    this._processCounter = this._processCounter + 1;
                    let processor = new DocumentModifierProcessor(this._core, event, id, this._callErrorHandler, this._callFailedHandler);
                    this._activeProcessors[id] = processor;
                    processor.process(this._documentProcessed, this._processorFinished);
                };
                this._processorFinished = (id, count) => {
                    this._log.info("DocumentModifierWidgetInstanceClass._processorFinished()");
                    // TODO: Figure out what we want to add to the activation context.
                    let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.BATCH_PROCESS_COMPLETE);
                    navEvent.Layout = this._currentLayout;
                    navEvent.PrimaryContext = this._activeProcessors[id].Event.Identifier;
                    this._core.Navigation.Details.requestActivation(navEvent);
                    delete this._activeProcessors[id];
                    if (!this._asynchronous) {
                        this._eventInProgress = false;
                        this._processEventQueue();
                    }
                };
                this._documentProcessed = (event, doc) => {
                    this._log.info("DocumentModifierWidgetInstanceClass._documentProcessed()");
                    if (this._suppressMessages)
                        return;
                    let config = this._config;
                    let navEvent = null;
                    if (event.EventType == 'EnterWorkflowQueue')
                        navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_ENTERED_WF);
                    else if (event.EventType == 'UpdateKeywords')
                        navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.DOCUMENT_KEYWORDS_UPDATED);
                    navEvent.ActivationID = doc.ItemNum;
                    navEvent.PrimaryContext = doc;
                    // Set default layout, but check if we've had an alternative requested against the instance
                    let targetLayoutName = this._currentLayout;
                    if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                        if (config.LaunchLayout == "[[CURRENT]]")
                            targetLayoutName = this._currentLayout;
                        else
                            targetLayoutName = config.LaunchLayout;
                    }
                    navEvent.Layout = targetLayoutName;
                    this._core.Navigation.Details.requestActivation(navEvent);
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("DocumentModifierWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                this._core.OBHelper.LoadQueues();
            }
            activate(context) {
                this._log.info("DocumentModifierWidgetInstanceClass.activate()");
                // Don't get stuck in a loop!
                if (!this._activationSourceValid(context))
                    return;
                // Check our queue size limit to help avoid activation loops
                if (this._eventQueue.length == 0)
                    this._flushingQueue = false;
                if (this._flushingQueue)
                    return;
                if (this._eventQueue.length >= this._queueSizeLimit) {
                    this._flushingQueue = true;
                    return;
                }
                if (this._triggers.length > 0) {
                    // Loop with iterator so we can escape when necessary
                    for (let i = 0; i < this._triggers.length; i++) {
                        let trigger = this._triggers[i];
                        if (this._core.Functions.triggerEventMatches(trigger, context)) {
                            if (trigger.Context) {
                                let queuedEvent = this._eventQueue.find(e => e.Identifier == trigger.Context);
                                if (!queuedEvent) {
                                    let triggeredEvent = this._events.find(e => e.Identifier == trigger.Context);
                                    if (triggeredEvent)
                                        this._eventQueue.push(triggeredEvent);
                                    else {
                                        console.warn(`DocumentModifier fired with trigger for undefined event ${trigger.Context}`);
                                    }
                                }
                            }
                        }
                        else {
                            continue;
                        }
                    }
                    this._processEventQueue();
                }
            }
        }
        DocumentModifierWidgetInstanceClass.HtmlData = null;
        Widgets.DocumentModifierWidgetInstanceClass = DocumentModifierWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
